import React, { useEffect } from "react";
import "./addUserModal.css";
import { Button, Form, Input, Select, Typography } from "antd";
import tickCircle from "../../Assets/img/tickcircle.png";
import { RoleModalVar } from "../../Utils/variables";
import { useDispatch, useSelector } from "react-redux";
import { formatCapabilities } from "../../Helpers/helpers";
import moment from "moment";
import { onAddRoleSubmit, onEditRoleSubmit } from "../../API-Interaction/apiServices/plantSettings.api";
import { error, success } from "../../Helpers/notification";

const {
  role_name,
  capabilities,
  demo,
  submit,
} = RoleModalVar;

const { Text } = Typography;

const RoleModal = ({ type, closeModal }) => {

  let dispatch = useDispatch();
  const { line } = useSelector(state => state?.plant?.current)
  const { plant } = useSelector(state => state?.plant?.current)
  const [form] = Form.useForm()

  useEffect(() => {
    if (type.key === 'edit')
      form.setFieldsValue({
        role: type?.value?.role,
        capabilities: type.value.capabilities
      });
    else if (type.key === 'add')
      form.setFieldsValue({
        role: "",
        capabilities: []
      });
  }, [type])


  //ADD ROLE
  const onFinishAddRole = (values) => {

    let body = {
      ...values,
      createdAt: `${moment(Date.now()).format(`YYYY-MM-DDThh:mm:ss.ms`)}Z`,
      lineId: line?.id,
      plantId: plant?._id,
      _id: `RO${moment(new Date()).format(`MMDDssms`)}`
    }
    onAddRoleSubmit(dispatch, body)
    success(`Role Added`)
    closeModal()


  };
  const onFinishFailedAddRole = (errorInfo) => {
    error(errorInfo)
  };

  //EDIT ROLE 
  const onFinishEditRole = (values) => {

    let body = {
      ...values,
      updatedAt: `${moment(Date.now()).format(`YYYY-MM-DDThh:mm:ss.ms`)}Z`,
      plantId: plant?._id,
      _id: type.value._id,
      role: type.value.role
    }
    onEditRoleSubmit(dispatch, body)
    success(`${type.value.role} Updated`)
    closeModal()


  };
  const onFinishFailedEditRole = (errorInfo) => {
    error(errorInfo)
  };

  let capabilitiesarr = [
    'view-all',
    'view-home',
    'view-dashboard',
    'view-machine-dashboard',
    'view-observer',
    'view-downtimeLog',
    'view-line-settings',
    'view-line-level-board',
    'view-plant-settings',
    'end-shift',
    'product-write-access',
    'edit-line-settings',
    'plant-role-access',
    'machine-access',
    'manual-entry',
    'update-downtimeLog',
    'audit-trail-access',
    'create-dynamicAdjustments-rework',
    'create-dynamicAdjustments-add-rejections',
    'view-integration-details',
    'view-leaderboard',
    // 'update-roles'
  ]
  // if (isSuperAdmin())
  // {
  //   capabilities.push('edit-role')
  //   capabilities.push('create-productionLine')
  //   capabilities.push('delete-productionLine')
  //   capabilities.push('create-plant')
  //   capabilities.push('delete-plant')
  // }

  if (line?.crfsEnabled)
    capabilitiesarr.push('crfs-enabled')

  if (line?.crfsHilal || line?.isPBL) {
    capabilitiesarr.push('crfs-hilal-maintenance')
    capabilitiesarr.push('crfs-hilal-merged')
  }
  
  if(plant?.isGSK){
    capabilitiesarr.push('change-date-filters-operator-page');
    capabilitiesarr.push('force-shift-stop-write');
    capabilitiesarr.push('support-button-write');
    capabilitiesarr.push('reports-access');
    capabilitiesarr.push('change-date-filters-line-performance');
    capabilitiesarr.push('change-date-filters-line-level-board');
    capabilitiesarr.push('product-change-line-operator');
    capabilitiesarr.push('rework-access');
    capabilitiesarr.push('add-rejections-access');
    capabilitiesarr.push('merge-downtime-access');
    capabilitiesarr.push('demerge-downtime-access');
    capabilitiesarr.push('mark-downtime-access');
    capabilitiesarr.push('change-date-filters-downtime-log');
    capabilitiesarr.push('edit-downtime-access');
    capabilitiesarr.push('line-information-access');
    capabilitiesarr.push('shift-access');
    capabilitiesarr.push('planned-downtime-access');
    capabilitiesarr.push('product-access');
    capabilitiesarr.push('weekly-access');
    capabilitiesarr.push('downtime-setting-access');
    capabilitiesarr.push('daily-target-access');
    capabilitiesarr.push('manual-entry-access');
    capabilitiesarr.push('plant-user-access');
    capabilitiesarr.push('plant-role-access');
    capabilitiesarr.push('plant-alerts-access');
    capabilitiesarr.push('site-champion-access');
    capabilitiesarr.push('generate-audit-report');
    capabilitiesarr.push('help-support-access');
    capabilitiesarr.push('user-export-report');
    capabilitiesarr.push('view-line-level-board');
    capabilitiesarr.push('weekly-target-access');
    capabilitiesarr.push('weekly-target-page');
  }

  return (
    <div>
      <Form
        form={form}
        name="basic"
        className="addRole"
        labelCol={{
          span: 6,
        }}
        wrapperCol={{
          span: 24,
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={type.key === 'edit' ? onFinishEditRole : onFinishAddRole}
        onFinishFailed={type.key === 'edit' ? onFinishFailedEditRole : onFinishFailedAddRole}
        autoComplete="off"
        requiredMark={true}
      >
        <h4 className="b-3">{role_name}</h4>
        <Form.Item
          name="role"
          rules={[
            {
              required: true,
              message: "Please input your role!",
            },
          ]}
        >
          <Input className="border1" />
        </Form.Item>
        <h4 className="b-3">{capabilities}</h4>
        <Form.Item name="capabilities" rules={[{required: true, message: "Enter Capabilities"}]}>
          <Select placeholder="Select Capabilities" mode="multiple">
            {capabilitiesarr.map(capability => (
              <Select.Option key={capability} value={capability}>
                {formatCapabilities(capability)}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item className="btn-align">
          <Button
            className="btn-width dflex alignCenter justifySB gap10"
            type="primary"
            htmlType="submit"
          >
            {" "}
            {submit} <img src={tickCircle} className="image-icon" />
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default RoleModal;
